import { Routes } from '@angular/router';
import { HomeComponent } from './modules/feature/home/home.component';
import { SigninComponent } from './modules/core/components/auth/signin/signin.component';
import { SignupComponent } from './modules/core/components/auth/signup/signup.component';
import { ProfileComponent } from './modules/core/components/auth/profile/profile.component';
import { SidebarComponent } from './modules/core/components/sidebar/sidebar.component';
import { PlayComponent } from './modules/feature/play/play.component';
import { UsernameComponent } from './modules/core/components/auth/username/username.component';
import { SettingsComponent } from './modules/feature/settings/settings.component';
import { StartPlayComponent } from './modules/feature/play/start-play/start-play.component';
// import { PuzzleComponent } from './modules/feature/puzzle/puzzle.component';
import { FriendsComponent } from './modules/core/components/auth/friends/friends.component';
import { authGuard } from './modules/core/auth.guard';
import { PuzzleComponent } from './modules/feature/puzzle/puzzle.component';
import { GameHistoryComponent } from './modules/feature/game-history/game-history.component';
import { HistoryChessBoardComponent } from './modules/feature/history-chess-board/history-chess-board.component';
import { EmptyPageComponent } from './modules/shared/empty-page/empty-page.component';
import { LeaderboardComponent } from './modules/feature/leaderboard/leaderboard.component';
import { ComplatedPuzzleComponent } from './modules/feature/puzzle/complated-puzzle/complated-puzzle.component';
import { DailyPuzzleComponent } from './modules/feature/puzzle/daily-puzzle/daily-puzzle.component';
import { OpeningsComponent } from './modules/feature/openings/openings.component';
import { OpeningDetailsComponent } from './modules/feature/openings/opening-details/opening-details.component';
import { ContactUsComponent } from './modules/feature/contact-us/contact-us.component';
import { BlogComponent } from './modules/feature/Blog/Blog.component';
import { PrivacyPolicyComponent } from './modules/core/components/auth/privacy-policy/privacy-policy.component';
import { CustomBlogComponent } from './modules/feature/Blog/custom-blog/custom-blog.component';
import { BlogDetailsComponent } from './modules/feature/Blog/blog-details/blog-details.component';
import { AdminGuard } from './modules/core/admin.guard';
import { AboutComponent } from './modules/core/components/about/about.component';
import { FairPlayComponent } from './modules/core/components/fair-play/fair-play.component';
import { UserAgreementComponent } from './modules/core/components/user-agreement/user-agreement.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, title: 'Home' },
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: SigninComponent,
    title: 'Login',
  },
  {
    path: 'useragreement',
    component: UserAgreementComponent,
    title: 'User-Agreement',
  },
  {
    path: 'about',
    component: AboutComponent,
    title: 'About',
  },
  {
    path: 'fairplay',
    component: FairPlayComponent,
    title: 'Fair-Play',
  },
  {
    path: 'news',
    component: BlogComponent,
    title: 'News',
  },
  {
    path: 'signup/username',
    component: UsernameComponent,
    title: 'Chess',
  },
  {
    path: 'privacyPolicy',
    component: PrivacyPolicyComponent,
    title: 'Privacy Policy',
  },
  {
    path: 'signup',
    component: SignupComponent,
    title: 'Signup',
  },
  {
    path: 'profile/:username',
    component: ProfileComponent,
    title: 'Profile',
    canActivate: [authGuard],
  },
  {
    path: 'Sidebar',
    component: SidebarComponent,
    title: '',
  },
  {
    path: 'database',
    component: GameHistoryComponent,
    title: 'player database',
  },
  // {
  //   path: 'leaderboard',
  //   component: LeaderboardComponent,
  //   title: 'Leader Board',
  //   canActivate: [authGuard],
  // },

  {
    path: 'play',
    component: PlayComponent,
    title: 'play',
  },
  {
    path: 'play/:id',
    component: StartPlayComponent,
    title: 'play',
    canActivate: [authGuard],
  },
  {
    path: 'historyboard/:id',
    component: HistoryChessBoardComponent,
    title: 'playerhistory',
    canActivate: [authGuard],
  },
  {
    path: 'puzzle',
    component: PuzzleComponent,
    title: 'puzzle',
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    title: 'Contact us',
  },
  {
    path: 'settings',
    component: SettingsComponent,
    title: 'Settings',
    canActivate: [authGuard],
  },
  {
    path: 'friends',
    component: FriendsComponent,
    title: 'Friend',
    canActivate: [authGuard],
  },
  {
    path: 'customNews',
    component: CustomBlogComponent,
    title: 'Custom-News',
    canActivate: [AdminGuard],
  },
  {
    path: 'newsetails/:id',
    component: BlogDetailsComponent,
    title: 'News-Details',
    canActivate: [authGuard],
  },
  {
    path: 'openings',
    component: OpeningsComponent,
    title: 'Openings',
    canActivate: [authGuard],
  },
  {
    path: 'openingdetails/:id',
    component: OpeningDetailsComponent,
    title: 'Openings-Details',
    canActivate: [authGuard],
  },
  {
    path: 'puzzle/complatedpuzzle',
    component: ComplatedPuzzleComponent,
    title: 'Solved Puzzle',
    canActivate: [authGuard],
  },
  {
    path: 'puzzle/dailypuzzle',
    component: DailyPuzzleComponent,
    title: 'Daily Puzzle',
    canActivate: [authGuard],
  },
  {
    path: '**',
    component: EmptyPageComponent,
    title: 'Not Found',
  },
];
